import React from 'react';
import Quotations from './quotation';

class Quotation extends React.Component {

  render() {
    return (
      <div>
        <div style={{padding: '0.5%'}}>
            <Quotations menus={this.props.menus} value={this.props.value} columnName={this.props.columnName}
             type={this.props.type} display={this.props.display} cancelcontol={this.props.cancelcontol}
             display1={this.props.display1} viewcontrol={this.props.viewcontrol} menuPermission={this.props.menuPermission}
             editcontrol={this.props.editcontrol} exportcontrol={this.props.exportcontrol} />
        </div>
      </div>
    );
  }
}

export default Quotation;
